import { DateTime } from 'luxon';
import { download } from './BaseApi';
import { Class, Student, StudentPHIAll } from '../model';

export async function downloadSolidPDF(
  classGrade: number,
  pids: string[],
  year: number,
  sem: number
): Promise<Blob> {
  return await download('/api/pdf/solid', {
    classGrade,
    pids,
    year,
    sem,
  });
}

export async function downloadExcel(
  schoolName: string,
  dates: string[],
  classes: Class[],
  year: number,
  sem: number
): Promise<Blob> {
  return await download('/api/pdf/fluor', {
    schoolName,
    dates,
    classes,
    year,
    sem,
  });
}

export async function downloadTeeExcel(
  schoolName: string,
  classes: Class[],
  title: string,
  year: number,
  sem: number
): Promise<Blob> {
  return await download('/api/pdf/tees', {
    schoolName,
    classes,
    title,
    year,
    sem,
  });
}

export async function downloadSightPDF(
  classId: string,
  pids: string[],
  year: number,
  sem: number,
  isPrintCurrentSem: boolean,
  isPrintHistories: boolean,
  deadline?: DateTime
): Promise<Blob> {
  return await download('/api/pdf/sight', {
    classId,
    pids,
    year,
    sem,
    isPrintCurrentSem,
    deadline: deadline?.toISO(),
    isPrintHistories,
  });
}

export async function downloadTeePDF(
  classId: string,
  pids: string[],
  year: number,
  sem: number,
  isContentEmpty: boolean,
  deadline?: DateTime
): Promise<Blob> {
  return await download('/api/pdf/tee', {
    classId,
    pids,
    year,
    sem,
    isContentEmpty,
    deadline: deadline?.toISO(),
  });
}

export enum ReceiptType {
  None = 0,
  Parent = 1,
  Treatment = 2,
}

export type WHSightReceiptSettings = {
  sightNormalBmiNormal: ReceiptType;
  sightNormalBmiAbnormal: ReceiptType;
  sightAbnormalBmiNormal: ReceiptType;
  sightAbnormalBmiAbnormal: ReceiptType;
};

export async function downloadWHSightPDF(
  classId: string,
  pids: string[],
  year: number,
  sem: number,
  receiptSettings: WHSightReceiptSettings,
  needPrintCurrentSight: boolean,
  needSeparateReceipt: boolean,
  needReceiptDeadline: boolean,
  isPrintFitWeight: boolean,
  receiptDeadline?: DateTime
): Promise<Blob> {
  return await download('/api/pdf/whsight', {
    classId,
    pids,
    year,
    sem,
    receiptSettings,
    needPrintCurrentSight,
    needSeparateReceipt,
    needReceiptDeadline,
    isPrintFitWeight,
    receiptDeadline: receiptDeadline?.toISO(),
  });
}

export async function downloadWHClassListPDF(
  classId: string,
  pids: string[],
  year: number,
  sem: number,
  isPrintFitWeight: boolean,
  isPrintHistories: boolean,
  deadline?: DateTime
): Promise<Blob> {
  return await download('/api/pdf/whclasslist', {
    classId,
    pids,
    year,
    sem,
    deadline: deadline?.toISO(),
    isPrintFitWeight,
    isPrintHistories,
  });
}

export async function downloadWH85210ClassListPDF(
  classId: string,
  pids: string[],
  year: number,
  sem: number,
  exportFitWeight: boolean,
  eportFitHeight: boolean,
  deadline?: DateTime
): Promise<Blob> {
  return await download('/api/pdf/wh85210', {
    classId,
    pids,
    year,
    sem,
    receiptDeadLine: deadline?.toISO(),
    exportFitWeight,
    eportFitHeight,
  });
}

export async function downloadCheckAgreePDF(
  classId: string,
  pids: string[],
  year: number,
  sem: number,
  isJunior: boolean,
  checkUnit?: string,
  checkDate?: DateTime,
  replyDate?: DateTime,
  studentReplyDate?: DateTime,
  checkHospitalTelRef?: string,
  checkHospitalTel0Ref?: string
): Promise<Blob> {
  return await download('/api/pdf/check-agree', {
    classId,
    pids,
    year,
    sem,
    isJunior,
    checkUnit,
    checkDate,
    replyDate,
    studentReplyDate,
    checkHospitalTelRef,
    checkHospitalTel0Ref
  });
}

export async function downloadCheckNotePDF(
  classId: string,
  pids: string[],
  year: number,
  sem: number,
  replyDate?: DateTime
): Promise<Blob> {
  return await download('/api/pdf/check-note', {
    classId,
    pids,
    year,
    sem,
    replyDate,
  });
}

export async function downloadWHHistoryClassListPDF(
  classId: string,
  pids: string[],
  year: number,
  sem: number,
  exportFitWeight: boolean,
  eportFitHeight: boolean,
  deadline?: DateTime
): Promise<Blob> {
  return await download('/api/pdf/whhistory', {
    classId,
    pids,
    year,
    sem,
    receiptDeadLine: deadline?.toISO(),
    exportFitWeight,
    eportFitHeight,
  });
}

export async function downloadWHHealthCard(
  studentPHI: StudentPHIAll,
  pids: string[]
): Promise<Blob> {
  return await download('/api/pdf/whhealthcard', {
    studentPHI,
    pids,
  });
}

export async function downloadWHHealthCards(
  healthGrade: string,
  pids: string[]
): Promise<Blob> {
  return await download('/api/pdf/whhealthcard/batch', {
    healthGrade,
    pids,
  });
}

export async function downloadWHBelowGHDPDF(
  // classId: string,
  pids: string[],
  year: number,
  sem: number
): Promise<Blob> {
  return await download('/api/pdf/whbelowghd', {
    // classId,
    pids,
    year,
    sem,
  });
}
